<template>
    <div class="nav-content-wrapper" v-if="!$store.state.waitingRequest">
        <admin-navbar />
        
        <div class="content">
            <h2>Modifier des jeux</h2>

            <table>
                <tr>
                    <th>Titre</th>
                    <th>Image</th>
                    <th>Nombre de vues</th>
                    <th>Likes</th>
                    <th>Dislikes</th>
                    <th>Date d'ajout</th>
                    <th>Catégorie</th>
                    <th>Modifier</th>
                    <th>Supprimer</th>
                </tr>
                <tr v-for="unJeu in lesJeux" :key="unJeu.id">
                    <td>{{ unJeu.title }}</td>
                    <td><a :href="'/games/'+unJeu.title_url" target="_blank"><img :src="'/games/static/miniatures/'+unJeu.image_url"></a></td>
                    <td>{{ unJeu.view_count }}</td>
                    <td>{{ unJeu.likes_count }}</td>
                    <td>{{ unJeu.dislikes_count }}</td>
                    <td>{{ unJeu.created_at }}</td>
                    <td>{{ unJeu.libelle_categorie }}</td>
                    <td><router-link :to="'editGame/'+unJeu.title_url"><i class="fas fa-edit"></i></router-link></td>
                    <td><a href="#" @click.prevent="deleteGame(unJeu, 'confirm')"><i class="fas fa-times-circle"></i></a></td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    import Session from '../mixins/adminSession';
    import AdminNavbar from '../views/AdminNavbar';

    export default {
        name: "AdminEditGames",
        mixins: [Session],
        components: {
            'admin-navbar': AdminNavbar
        },
        data() {
            return {
                lesJeux: []
            }
        },
        mounted() {
            this.getAllGames();
        },
        methods: {
            getAllGames() {
                let formData = new FormData();
                formData.append('data', JSON.stringify({post: "1"}));
                
                axios
                .post(
                this.$store.state.apiUrl+"?request=getAllGames", formData
                )
                .then((response) => {
                    if(response.data.length > 0) {
                        this.lesJeux = response.data;
                    }
                });
            },
            deleteCommentsGame(game) {
                let formData = new FormData();
                formData.append('data', JSON.stringify({ post: "1", gameId: game.id }));
                
                axios.post(this.$store.state.apiUrl+"?request=deleteCommentsGame", formData)
                .then((response) => {
                    if(response.data) {
                        this.deleteGame(game, 'delete');
                    }
                });
            },
            deleteGame(game, action) {
                if(action == 'confirm') {
                    action = confirm('Souhaitez-vous vraiment supprimer le jeu "'+ game.title +'" ?');
                } else {
                    action = true;
                }

                if (action) {
                    let formData = new FormData();
                    formData.append('data', JSON.stringify({post: "1", id: game.id, image_url: game.image_url}));
                    
                    axios
                    .post(this.$store.state.apiUrl+"?request=deleteGame", formData)
                    .then((response) => {
                        if(response.data == true) {
                            alert('Le jeu a bien été supprimé');
                            this.getAllGames();
                        }
                        else if(response.data == 'featured') {
                            alert("Le jeu ne peut pas être supprimé car il est mis en avant");
                        }
                        else if(response.data == 'comments') {
                            if (confirm('Des commentaires concernent ce jeu, souhaitez-vous quand même le supprimer ainsi que tous ses commentaires ?')) {
                                this.deleteCommentsGame(game);
                            }
                        }
                        else {
                            alert("Le jeu n'a pas été supprimé");
                        }
                    });
                }
            }
        }
    }
</script>

<style scoped src="@/assets/admin.css">
</style>
